'use strict';

var _plugins = require('./plugins');


/*****************
 ** WEBPACK FOOTER
 ** ./~/radium/lib/config.js
 ** module id = 7
 ** module chunks = 0
 **/